import type { UserSettings } from '@atnt/shared';
import i18n from '@/shared/i18n';

/** Apply interface settings ("Interfeys sozlamalari") to the document: theme, accent, language. */
export function applyUserPreferences(settings: Partial<UserSettings>) {
  const root = document.documentElement;
  if (settings.theme) root.dataset.theme = settings.theme;
  if (settings.accentColor) root.style.setProperty('--ds-accent', settings.accentColor);
  if (settings.locale && i18n.language !== settings.locale) {
    void i18n.changeLanguage(settings.locale);
    root.lang = settings.locale.startsWith('uz') ? 'uz' : settings.locale;
  }
}
